import React, { forwardRef } from 'react';

import { EntityViewProps } from './index.types';
import { EntityView } from './index.view';

export function EntityComponent(
  props: EntityViewProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return <EntityView {...props} ref={ref} />;
}

export default forwardRef(EntityComponent);
